// @flow

import { connect } from 'react-redux';

import { DateProvider } from '@zapier/date';

import * as Profile from 'app/entities/Profile';

const mapStateToProps = state => {
  const profile = Profile.selectors.all.currentProfile(state);

  return {
    timezone: Profile.selectors.timezone(profile),
  };
};

export default connect(mapStateToProps)(DateProvider);
